<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2022 (original work) Open Assessment Technologies SA ;
    import { Icon } from '@oat-sa-private/ui-elements';
    export let name = '';
    export let size = 'normal';
    export let seed = name ?? Math.random();

    const colorsArray = [
        '#6403FF',
        '#B10849',
        '#8405D8',
        '#8E3585',
        '#904300',
        '#785200',
        '#4D6006',
        '#2F6255',
        '#046176',
        '#5A5957'
    ];

    /**
     * Generate numeric value from string using character codes
     * Same string will always return same numeric value
     * @param {string} str
     * @returns {number}
     */
    const toNumber = str => [...str].reduce((acc, char) => acc + char.charCodeAt(0), 0);

    /**
     * Transform string to color from colors array
     * @param {string} str
     * @param {string[]} colors
     * @returns {string}
     */
    const stringToColor = (str, colors) => colors[Math.abs(toNumber(str)) % colors.length];

    /**
     * Get size value
     * @param {string|number} value
     * @returns {string}
     */
    const getSize = (value) => {
        if (typeof value === 'number') {
            return `${value}px`;
        }

        if (value === 'small') {
            return '3rem';
        } else if (value === 'normal') {
            return '4rem';
        } else if (value === 'large') {
            return '6rem';
        }

        return value;
    };

    $: initials = name
        .trim()
        .split(' ')
        .reduce((acc, part, index, arr) => {
            if (index === 0 || index === arr.length - 1) {
                acc.push(part);
            }
            return acc;
        }, [])
        .map((part) => part[0]?.toUpperCase())
        .join('');
    $: background = stringToColor(seed, colorsArray);
    $: sizeValue = getSize(size);
</script>

<style>
    .avatar {
        --background: var(--color-gs-light-secondary);
        display: flex;
        align-items: center;
        justify-content: center;
        width: var(--size);
        height: var(--size);
        border-radius: 100%;
        background-color: var(--bg-color);
        color: var(--color-gs-light-alternative-bg);

        & .icon :global(svg) {
            height: calc(var(--size) * 0.4375);
            width: auto;
        }
    }

    .initials {
        font-size: calc(var(--size) * 0.4375);
        line-height: calc(var(--size) * 0.625);
        font-weight: 700;
        user-select: none;
    }
</style>

<span
    class="avatar"
    role="img"
    aria-label={name}
    style={`
        --size: ${sizeValue};
        --bg-color: ${background};
    `}
>
    {#if initials}
    <span class="initials">{initials}</span>
    {:else}
    <span class="icon">
        <Icon name="user-16" />
    </span>
    {/if}
</span>
